<!--
 * @Description: 
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: zml
 * @LastEditTime: 2026-07-21 11:07:43
-->
<template>
  <div class="bgOne">
    <!-- <div v-if="!userInfo.id && $templates() === 'themeTemplateOne' && TENANTID === 470761814249541">
      <router-view></router-view>
    </div> -->
    <el-container>
      <el-header height="auto">
        <layout-header></layout-header>
      </el-header>
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </el-main>
      <el-footer height="auto">
        <layoutFooterTwo></layoutFooterTwo>
      </el-footer>
    </el-container>
    <div class="elBacktop">
      <el-backtop></el-backtop>
    </div>
  </div>
</template>
<script>
import LimitModel from "@/components/limitModel/index.vue";
import { mapActions, mapState } from "vuex";
import { ProductClassWebGetTree, SysWebSiteConfigGetDetail, GetTreeByProductCount } from "@/api/home";
import { TENANTID } from "@/store/mutation-types";
import layoutHeader from "./layoutHeader.vue";
// import layoutFooter from './layout/layoutFooter'
import layoutFooterTwo from "./layoutFooterTwo.vue";
export default {
  name: "pcLayout",
  components: {
    LimitModel,
    layoutHeader,
    // layoutFooter,
    layoutFooterTwo,
  },
  data() {
    return {
      TENANTID,
      isPassLimit: false,
    };
  },
  created() {
    console.log(this.isPassPages);
    this.init();
  },
  computed: {
    ...mapState("operate", ["language", "isPassPages"]),
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    ...mapActions("setting", {
      setMenus: "set_menus",
      setLanguageConfig: "set_language_config",
    }),
    ...mapActions("operate", {
      setLanguage: "set_language",
    }),
    async init() {
      let _this = this;
      // 站点语言
      await SysWebSiteConfigGetDetail()
        .then((res) => {
          if (res.success) {
            _this.setLanguageConfig(res.data);
            if (!window.localStorage.getItem("i18n")) {
              if (res.data.defaultLanguage === "zh-Hans") {
                _this.setLanguage("zh");
                window.location.reload();
              } else {
                _this.setLanguage(res.data.defaultLanguage);
                window.location.reload();
              }
            }
          } else {
            _this.$message(res.message);
          }
        })
        .catch((err) => {
          _this.$message({ err });
        });
      await GetTreeByProductCount()
        .then((res) => {
          if (res.success) {
            _this.setMenus(res.data);
          } else {
            _this.$message(res.message);
          }
        })
        .catch((err) => {
          _this.$message({ err });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-header,
.el-footer,
.el-main {
  padding: 0;
}

:deep .container {
  width: 1200px; //one模板
}

.el-main {
  min-height: 400px;
}

:deep .el-backtop {
  background-color: #3191d8;
  width: 50px;
  height: 50px;
  i {
    color: #fff;
    font-size: 25px;
  }
}
</style>
